import menu from "./menu.json";
import pagination from "./pagination.json";
import selected_transactions from "./selected-transactions.json";
import selection_calculations from "./selection-calculator.json";
import year_selector from "./year-selector.json";
import summary from "./summary.json";
import attachments_selector from "./attachments-selector.json";
import strings from "./strings.json";
import charts from "./charts.json";
import status from "./status.json";
import footer from "./footer.json";

export default {
  menu,
  pagination,
  selection_calculations,
  year_selector,
  summary,
  attachments_selector,
  strings,
  charts,
  status,
  selected_transactions,
  footer,
};
